import React from 'react';
import { Outlet } from 'react-router-dom';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import useAlert from '../../hooks/useAlert';
// import useStyles from './Widget.style';

// import PropTypes from 'prop-types';

const Widget = () => {
  // const classes = useStyles();
  const { alertStates, alert } = useAlert();
  return (
    <>
      <Outlet />
      <If condition={!!alertStates?.message}>
        <Snackbar
          open={!!alertStates?.message}
          autoHideDuration={5000}
          onClose={() => {
            alert();
          }}
        >
          <Alert
            elevation={6}
            variant="filled"
            onClose={() => {
              alert();
            }}
            severity={alertStates?.type}
          >
            {alertStates?.message}
          </Alert>
        </Snackbar>
      </If>
    </>
  );
};

Widget.propTypes = {};

export default Widget;
